import styled from 'styled-components';
import { elevation } from '@legacy-vfuk/core-mixins';

const lineClamp = (linesQuantity: number) => `
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: ${linesQuantity};
  -webkit-box-orient: vertical;
`;


export const SolutionsWrapper = styled.div`
  background: var(--white);
`;

export const SolutionsContainer = styled.div`
  margin: 150px auto;
  max-width: 1920px;

  @media (max-width: 1024px) {
    margin: auto;
  }
  
`;

export const SolutionCardWrapper = styled.div<{
  direction: 'ltr' | 'rtl';
  media?: boolean;
}>`
  background: var(--gallery);
  text-align: start;
  overflow: hidden;
  border-radius: 6px;

  ${elevation(true)}
 
  @media only screen and (min-width: 1151px) {
    transition: all 0.2s ease-in-out;
    :hover {
      transform: scale(1.05);
    }
  }
  .summary {
    ${lineClamp(3)}
    height: 83px;
  }
`;

export const HeaderWrapper = styled.p`
  font-size: 22px;
  font-weight: bold;
`;

export const MediaImageWrapper = styled.div`
  position: relative;
  & > [data-gatsby-image-wrapper] {
    width: 100%;
    height: 230px;
  }
`;

export const ImageOverlay = styled.div`
  position: absolute;
  height: 230px;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(37, 40, 43, 0) 18.95%,
    rgba(37, 40, 43, 0.64) 81.05%
  );
`;

export const ContentWrapper = styled.div`
  margin: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const SolutionsContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;

export const SolutionsText = styled.div`
  flex: 1;
`;

export const SolutionsCards = styled.div`
  margin-left: 20px;
  flex: 2;

  @media (max-width: 1024px) {
    margin-left: 0px;
  }
  
`;

export const ButtonRowWrapper = styled.div`
  [class*='SimpleGridstyle__SimpleGridColumn-sc'] {
    width: 100% !important;
  }
  a {
    width: 100% !important;
  }
`;


